var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecurring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3887 24.5576V24.5576C11.3887 18.4358 16.3514 13.4731 22.4731 13.4731H33.5576M33.5576 13.4731L29.6455 8.72266M33.5576 13.4731L29.6455 18.2236",
    stroke: "black",
    strokeWidth: 1.07812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5576 22.4463V22.4463C33.5576 28.5681 28.5949 33.5308 22.4731 33.5308H11.3887M11.3887 33.5308L15.3008 38.2812M11.3887 33.5308L15.3008 28.7803",
    stroke: "black",
    strokeWidth: 1.07812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.0095,
    cy: 30.4865,
    r: 8.39669,
    fill: "#EF2C5A",
    stroke: "black",
    strokeWidth: 0.730147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6443 34.3144C34.8811 34.3144 34.1961 33.8413 33.9184 33.1226L33.5587 32.1928C33.5218 32.1083 33.4826 32.0537 33.4411 32.0283C33.3994 32.0029 33.3317 31.9902 33.2382 31.9902H33.0781L32.9833 32.7762C32.8773 33.6542 32.1402 34.3144 31.2656 34.3144L32.0001 28.2722C32.1067 27.3942 32.8442 26.7344 33.7191 26.7344L33.2034 30.9827H33.3084C33.3953 30.9827 33.4652 30.9692 33.5187 30.9423C33.572 30.9153 33.6256 30.8663 33.6789 30.7954L34.4313 29.7528C34.7397 29.3256 35.23 29.0717 35.7529 29.0689L36.6329 29.0637L35.1809 30.9321C35.114 31.02 35.0407 31.0977 34.9605 31.1651C34.8804 31.2327 34.7968 31.2917 34.7102 31.3423C34.7804 31.3998 34.8412 31.4664 34.8929 31.5423C34.9447 31.6182 34.9905 31.7052 35.0305 31.8032L36.0719 34.3146H35.6443V34.3144Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurring);
export default __webpack_public_path__ + "static/media/recurring.8e6fc3939b6e9f9aa1fad1c40c647dd8.svg";
export { ForwardRef as ReactComponent };